import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import { successColor } from "../../assets/jss/material-dashboard-react";
import { Paper, Typography, Box } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginTop: "2%",
    marginBottom: "4%"
  },
  logoImage: {
    backgroundSize: "cover",
    width: "60%",
    height: "60%",
    borderRadius: "50%",
    animation: ` $colorChange 6s ease-in-out infinite`,
    transition: "transform 0.5s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  "@keyframes float": {
    "0%": {
      transform: "translateY(0px)",
    },
    "50%": {
      transform: "translateY(-20px) translateX(-20px)",
    },
    "100%": {
      transform: "translateY(0px)",
    },
  },
  "@keyframes colorChange": {
    "0%": {
      filter: "hue-rotate(0deg)",
    },
    "50%": {
      filter: "hue-rotate(180deg)",
    },
    "100%": {
      filter: "hue-rotate(360deg)",
    },
  },
}));

export default function Home() {
  const classes = useStyles();

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Box textAlign="center">
          <h1
            style={{
              fontSize: "4rem",
              fontWeight: "bold",
              color: successColor[0],
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
              margin: 0,
            }}
          >
            FRUITrank
          </h1>
          <p
            style={{
              fontSize: "1.5rem",
              color: "#555",
              marginTop: "0.5rem",
              fontStyle: "italic",
            }}
          >
            Platforma za rangiranje poljoprivrednih kultura
          </p>
        </Box>
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <div className={classes.logoContainer}>
          <img
            src={require("../../assets/img/logo.png")}
            alt="Logo"
            className={classes.logoImage}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={12} md={6} style={{ paddingLeft: "10rem", alignSelf: 'left' }}>
        <Paper
          elevation={3}
          style={{
            backgroundColor: successColor[0],
            color: "#fff",
            padding: "2rem",
            borderRadius: "10px",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            align="center"
            style={{ fontWeight: "bold", marginBottom: "0.5rem" }}
          >
            Rangiranje alternativa
          </Typography>
          <Typography
            variant="h6"
            component="h6"
            align="center"
            style={{ marginBottom: "1.5rem" }}
          >
            FRUITrank
          </Typography>
          <Typography
            variant="body1"
            component="p"
            style={{ fontSize: "1 rem", textAlign: "justify" }}
          >
            Dobrodošli na platformu za rangiranje poljoprivrednih kultura!{" "}
            <br />
            Ovdje možete jednostavno uporediti različite kulture na temelju
            specifičnih kriterijuma koji su važni za poljoprivrednu praksu.
            Platforma je dizajnirana kako bi Vam pomogla da brzo i lako
            odaberete najpogodnije kulture za Vaše poljoprivredno zemljište i
            potrebe. <br />
            Jednostavno unesite tražene podatke, a naš sistem će ih obraditi i
            prikazati rezultate rangiranja u skladu s kriterijumima. Ovo je
            praktičan alat za poljoprivrednike, agronome i istraživače koji
            traže precizna poređenja, bez dodatnih komplikacija.
          </Typography>
        </Paper>
      </GridItem>
    </GridContainer>
  );
}

